export const QUEUE_IDS = {
  TRANS_UNMATCH_QUEUE_ID: 6,
  AMEX_QUEUE_ID: 71,
  WEX_QUEUE_ID: 80,
  UNMATCHED_SCHEME_IMAGE: 9,
  UNMATCHED_MERCHANT_IMAGE: 15,
  MERCHANT_UNMATCH_QUEUE_ID: 8,
  ACTIVE_STAGE: 81
};